export default __webpack_public_path__ + "static/media/Multiplication_04.cec673ac.png";